import { FormEvent, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useFeedback } from '../../hooks/useFeedback';
import { getApiErrorMessage } from '../../utils/apiError';
import '../LoginPage/LoginPage.css';

const CreateClubPage = () => {
  const [clubName, setClubName] = useState('');
  const [isPilot, setIsPilot] = useState(true);
  const [saving, setSaving] = useState(false);
  const { createAdditionalClub, isAuthenticated, loading, isGuest, isTechnician } =
    useAuth();
  const { showError, feedbackNode } = useFeedback();
  const navigate = useNavigate();

  if (!loading && (!isAuthenticated || isGuest || isTechnician)) {
    return <Navigate to={isAuthenticated ? '/' : '/login'} replace />;
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const name = clubName.trim();
    if (!name) {
      showError('Укажите название клуба');
      return;
    }
    setSaving(true);
    try {
      await createAdditionalClub(name, isPilot);
      navigate('/club');
    } catch (err) {
      showError(getApiErrorMessage(err, 'Не удалось создать клуб'));
    }
    setSaving(false);
  };

  return (
    <div className="login-page">
      {feedbackNode}
      <div className="login-card">
        <img src="/plane.png" alt="" className="login-icon" />
        <h1>Новый клуб</h1>
        <p className="login-subtitle">
          Создайте ещё один клуб — вы будете владельцем. Текущий аккаунт сохранится.
        </p>
        <form onSubmit={handleSubmit}>
          <label className="login-field">
            <span>Клуб</span>
            <input
              type="text"
              placeholder="Название клуба"
              value={clubName}
              onChange={(e) => setClubName(e.target.value)}
              required
              maxLength={120}
            />
          </label>
          <fieldset className="login-field">
            <legend>Вы пилот / собственник доли в этом клубе?</legend>
            <div className="login-choice">
              <label className="login-choice-option">
                <input
                  type="radio"
                  name="is_pilot"
                  checked={isPilot}
                  onChange={() => setIsPilot(true)}
                />
                <span>Да — полёты, брони и доли</span>
              </label>
              <label className="login-choice-option">
                <input
                  type="radio"
                  name="is_pilot"
                  checked={!isPilot}
                  onChange={() => setIsPilot(false)}
                />
                <span>Нет — только управление клубом</span>
              </label>
            </div>
          </fieldset>
          <button type="submit" disabled={saving}>
            {saving ? 'Создание...' : 'Создать клуб'}
          </button>
        </form>
        <p className="login-footer">
          <Link to="/">Назад</Link>
        </p>
      </div>
    </div>
  );
};

export default CreateClubPage;
